import { useAuth } from '../jwt/JwtContext'; // Corrected named import
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const AuthGuard = ({ children }) => {
  const { user, loading } = useAuth(); // Destructure loading
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) { // Only check after loading is complete
      if (!user) {
        
        console.log('No user found, redirecting to login'); // Debugging
        navigate('/auth/login', { replace: true });
      } else {
        console.log('User authenticated:', user); // Debugging
      }
    }
  }, [user, loading, navigate]);

  if (loading) {
    // Optionally, render a loading indicator while checking authentication
    return null; // Or a spinner/loading component
  }

  return children;
};

export default AuthGuard;